<template>
<div>
    <!--  -->
    <div v-if="anio2 > 0  &&  anio2 <= 2015">
        <h5 class="subtitulo2 mt-5">Normatividad Financiera {{anio2}}</h5>
        <!--  -->
        <div class="accordion mt-4" id="accordionExample">
            <div class="card">
                <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style="display:flex; justify-content:space-between;">
                    <span>Normatividad Financiera del Estado </span>
                    <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                    </button>
                </h2>
                </div>

                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body">
                        <UL>
                            <LI><A :href="urlServe+ruta + anio2 +'/TituloI.pdf'" target="_blank">Título I - De la Administración Pública Centralizada</A> </LI>
                            <LI><A :href="urlServe+ruta + anio2 +'/TituloII.pdf'" target="_blank">Título II - De la Administración Paraestatal</A> </LI>
                            <LI><A :href="urlServe+ruta + anio2 +'/TituloIII.pdf'" target="_blank">Título III - De los Poderes Legislativo, Judicial y de los Organismos Subsidiados, Sectorizados y Autónomos</A> </LI>
                            <LI><A :href="urlServe+ruta + anio2 +'/TituloIV.pdf'" target="_blank">Título IV. De los Municipios</A> </LI>
                            <LI><A :href="urlServe+ruta + anio2 +'/TituloV.pdf'" target="_blank">Título V. De las Publicaciones Oficiales</A> </LI>
                            <LI v-if="anio2 != 2010"><A :href="urlServe+ruta + anio2 +'/TituloVI.pdf'" target="_blank">Título VI - De los Recursos Federales</A> </LI>
                            <!-- otras condiciones -->
                            <LI v-if="anio2==2010 || anio2==2011 || anio2==2013"><A :href="urlServe+ruta + anio2 +'/' + '/Formatos.'   +tipo" target="_blank">Formatos</A> </LI>
                            <LI v-if="anio2==2010 || anio2==2011"><A :href="urlServe+ruta + anio2 +'/' + '/Instructivo.'+tipo" target="_blank">Instructivo de llenado de los formatos</A> </LI>
                        </UL>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->
    <div v-if="anio2 >= 2016 && anio2 < 2020">
            <h5 class="subtitulo2 mt-5">Normatividad Financiera {{anio2}}</h5>
            <!--  -->
            <div class="accordion mt-4" id="accordionExample">
                <div class="card">
                    <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style="display:flex; justify-content:space-between;">
                        <span>Normatividad Financiera del Estado </span>
                        <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                        </button>
                    </h2>
                    </div>

                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                        <div class="card-body">
                            <!-- aqui ul -->
                            <div class="d-flex" style=" justify-content:space-between;">
                                <p>
                                    <i v-if="doc" class="far fa-file-word"></i>
                                    <i v-if="pdf" class="far fa-file-pdf"></i>
                                    Archivos {{tipo}}
                                </p>
                                <div class="pointer">
                                    <a @click="cambio" class="cambio">Cambiar a {{archivo}} </a>
                                    <!-- <a href="">.pdf</a> -->
                                </div>
                            </div>
                            <hr class="mb-3 mt-0">
                            <UL>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-I.'   +tipo" target="_blank">Título I - De la Administración Pública Centralizada</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-II.'  +tipo" target="_blank">Título II - De la Administración Paraestatal</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-III.' +tipo" target="_blank">Título III - De los Poderes Legislativo, Judicial y de los Organismos Subsidiados, Sectorizados y Autónomos</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-IV.'  +tipo" target="_blank">Título IV. De los Municipios</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-V.'   +tipo" target="_blank">Título V. De las Publicaciones Oficiales</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-VI.'  +tipo" target="_blank">Título VI - De los Recursos Federales</A> </LI>
                                <!-- condiciones extras -->
                                <span v-if="anio2==2018">
                                    <LI>
                                        <A :href="urlServe+ruta + anio2 +'/' + '/fe-erratas-nf18.pdf'" target="_blank">
                                            Fe de Erratas a la publicación número 2404-A-2018 del Acuerdo por el que se expide la Normatividad Financiera del Estado para el Ejercicio Fiscal 2018, publicado en el Periódico Oficial número 361, Tomo III de 04 de Abril de 2018.
                                        </A>
                                    </LI>
                                </span>
                                <span v-if=" anio2==2019 || anio2==2020">
                                    <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Formatos.'   +tipo" target="_blank">Formatos</A> </LI>
                                    <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Instructivo.'+tipo" target="_blank">Instructivo de llenado de los formatos</A> </LI>
                                </span>
                            </UL>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <!--  -->
        <div v-if="anio2 ==  2020">
            <h5 class="subtitulo2 mt-5">Normatividad Financiera {{anio2}}</h5>
            <!--  -->
            <div class="accordion mt-4" id="accordionExample">
                <div class="card">
                    <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style="display:flex; justify-content:space-between;">
                        <span>Normatividad Financiera del Estado </span>
                        <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                        </button>
                    </h2>
                    </div>

                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                        <div class="card-body">
                            <!-- aqui ul -->
                            <div class="d-flex" style=" justify-content:space-between;">
                                <p>
                                    <i v-if="doc" class="far fa-file-word"></i>
                                    <i v-if="pdf" class="far fa-file-pdf"></i>
                                    Archivos {{tipo}}
                                </p>
                                <div class="pointer">
                                    <a @click="cambio" class="cambio">Cambiar a {{archivo}} </a>
                                    <!-- <a href="">.pdf</a> -->
                                </div>
                            </div>
                            <hr class="mb-3 mt-0">
                            <UL>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-I.'+tipoAnio" target="_blank">Título I - De la Administración Pública Centralizada</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/PDF/Titulo-II.pdf'" target="_blank">Título II - De los Poderes Legislativo, Judicial y de los Organismos Subsidiados, Sectorizados y Autónomos</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-III.'+tipoAnio"  target="_blank">Título III. De los Municipios</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-IV.'+tipoAnio"   target="_blank">Título IV. De las Publicaciones Oficiales</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-V.'+tipoAnio"  target="_blank">Título V - De los Recursos Federales</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Formatos.'+tipo" target="_blank">Formatos</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Instructivo.'+tipo" target="_blank">Instructivo de llenado de los formatos</A> </LI>

                            </UL>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--  -->
    <div v-if="anio2 ==  2021">
            <h5 class="subtitulo2 mt-5">Normatividad Financiera {{anio2}}</h5>
            <!--  -->
            <div class="accordion mt-4" id="accordionExample">
                <div class="card">
                    <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style="display:flex; justify-content:space-between;">
                        <span>Normatividad Financiera del Estado </span>
                        <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                        </button>
                    </h2>
                    </div>

                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                        <div class="card-body">
                            <!-- aqui ul -->
                            <div class="d-flex" style=" justify-content:space-between;">
                                <p>
                                    <i v-if="doc" class="far fa-file-word"></i>
                                    <i v-if="pdf" class="far fa-file-pdf"></i>
                                    Archivos {{tipo}}
                                </p>
                                <div class="pointer">
                                    <a @click="cambio" class="cambio">Cambiar a {{archivo}} </a>
                                    <!-- <a href="">.pdf</a> -->
                                </div>
                            </div>
                            <hr class="mb-3 mt-0">
                            <UL>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-I.'+tipoAnio" target="_blank">Título I - De la Administración Pública Centralizada y Paraestatal</A> </LI>
                                <!-- <LI><A href="#">Título II - De la Administración Paraestatal</A> </LI> -->
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-II.'+tipoAnio" target="_blank">Título II - De los Poderes Legislativo, Judicial y de los Organismos Subsidiados, Sectorizados y Autónomos</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-III.'+tipoAnio"  target="_blank"> Título III - De los Municipios</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-IV.'+tipoAnio"   target="_blank">Título IV. De las Publicaciones Oficiales</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-V.'+tipoAnio"  target="_blank">Título V. De los Recursos Federales</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Formatos.'   +tipoAnio" target="_blank">Formatos</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Instructivo.'   +tipoAnio" target="_blank">Instructivo de llenado de los formatos</A> </LI>
                                <!-- {{tipo}} -->
                            </UL>
                        </div>
                    </div>
                </div>
            </div>
    </div>
        <!--  -->
        <!--  -->
    <div v-if="anio2 ==  2022">
            <h5 class="subtitulo2 mt-5">Normatividad Financiera {{anio2}}</h5>
            <!--  -->
            <div class="accordion mt-4" id="accordionExample">
                <div class="card">
                    <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style="display:flex; justify-content:space-between;">
                        <span>Normatividad Financiera del Estado </span>
                        <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                        </button>
                    </h2>
                    </div>

                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                        <div class="card-body">
                            <!-- aqui ul -->
                            <div class="d-flex" style=" justify-content:space-between;">
                                <p>
                                    <i v-if="doc" class="far fa-file-word"></i>
                                    <i v-if="pdf" class="far fa-file-pdf"></i>
                                    Archivos {{tipo}}
                                </p>
                                <div class="pointer">
                                    <a @click="cambio" class="cambio">Cambiar a {{archivo}} </a>
                                    <!-- <a href="">.pdf</a> -->
                                </div>
                            </div>
                            <hr class="mb-3 mt-0">
                            <UL>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-I.'+tipoAnio" target="_blank">Título I - De la Administración Pública Centralizada y Paraestatal</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-II.'+tipoAnio" target="_blank">Título II - De los Poderes Legislativo, Judicial y de los Organismos Subsidiados, Sectorizados y Autónomos</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-III.'+tipoAnio"  target="_blank"> Título III - De los Municipios</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-IV.'+tipoAnio"   target="_blank">Título IV. De las Publicaciones Oficiales</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-V.'+tipoAnio"  target="_blank">Título V. De los Recursos Federales</A> </LI>

                            </UL>
                        </div>
                    </div>
                </div>
            </div>
    </div>
        <!--  -->
    <div v-if="anio2 ==  2023">
            <h5 class="subtitulo2 mt-5">Normatividad Financiera {{anio2}}</h5>
            <!--  -->
            <div class="accordion mt-4" id="accordionExample">
                <div class="card">
                    <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style="display:flex; justify-content:space-between;">
                        <span>Normatividad Financiera del Estado </span>
                        <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                        </button>
                    </h2>
                    </div>

                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                        <div class="card-body">
                            <!-- aqui ul -->
                            <div class="d-flex" style=" justify-content:space-between;">
                                <p>
                                    <i v-if="doc" class="far fa-file-word"></i>
                                    <i v-if="pdf" class="far fa-file-pdf"></i>
                                    Archivos {{tipo}}
                                </p>
                                <div class="pointer">
                                    <a @click="cambio" class="cambio">Cambiar a {{archivo}} </a>
                                    <!-- <a href="">.pdf</a> -->
                                </div>
                            </div>
                            <hr class="mb-3 mt-0">
                            <UL>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Presentacion.'+tipoAnio" target="_blank">Presentación</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Disp-Gen.'+tipoAnio" target="_blank">Disposiciones Generales</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-I.'+tipoAnio" target="_blank">Título I - De la Administración Pública Centralizada y Paraestatal</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-II.'+tipoAnio" target="_blank">Título II - De los Poderes Legislativo, Judicial y de los Organismos Subsidiados, Sectorizados y Autónomos</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-III.'+tipoAnio"  target="_blank"> Título III - De los Municipios</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-IV.'+tipoAnio"   target="_blank">Título IV. De las Publicaciones Oficiales</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-V.'+tipoAnio"  target="_blank">Título V. De los Recursos Federales</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-VI.'+tipoAnio"  target="_blank">Título VI. De las Inversiones Financieras</A> </LI>
                                <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Transitorios.'+tipoAnio"  target="_blank">Transitorios</A> </LI>

                            </UL>
                        </div>
                    </div>
                </div>
            </div>
    </div>
        <!---->
    <div v-if="anio2 ==  2024">
        <h5 class="subtitulo2 mt-5">Normatividad Financiera {{anio2}}</h5>
        <!--  -->
        <div class="accordion mt-4" id="accordionExample">
            <div class="card">
                <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style="display:flex; justify-content:space-between;">
                    <span>Normatividad Financiera del Estado </span>
                    <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                    </button>
                </h2>
                </div>

                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body">
                        <!-- aqui ul -->
                        <div class="d-flex" style=" justify-content:space-between;">
                            <p>
                                <i v-if="doc" class="far fa-file-word"></i>
                                <i v-if="pdf" class="far fa-file-pdf"></i>
                                Archivos {{tipo}}
                            </p>
                            <div class="pointer">
                                <a @click="cambio" class="cambio">Cambiar a {{archivo}} </a>
                                <!-- <a href="">.pdf</a> -->
                            </div>
                        </div>
                        <hr class="mb-3 mt-0">
                        <UL>
                            <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Presentacion.'+tipoAnio" target="_blank">Presentación</A> </LI>
                            <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Disp-Gen.'+tipoAnio" target="_blank">Disposiciones Generales</A> </LI>
                            <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-I.'+tipoAnio" target="_blank">Título I. Obligaciones de los Organismos Públicos del Estado y de la Tesorería Única </A> </LI>
                            <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-II.'+tipoAnio" target="_blank">Titulo II. Administración Pública Centralizada y Paraestatal</A> </LI>
                            <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-II-BIS.'+tipoAnio" target="_blank">Título II (BIS). De los Poderes Legislativo, Judicial y de los Organismos Subsidiados, Sectorizados y Autónomos</A> </LI>
                            <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-III.'+tipoAnio"  target="_blank">Título III. Municipios</A> </LI>
                            <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-IV.'+tipoAnio"   target="_blank">Título IV. De las Publicaciones Oficiales</A> </LI>
                            <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-V.'+tipoAnio"  target="_blank">Título V. Recursos Federales Autorizados</A> </LI>
                            <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Titulo-VI.'+tipoAnio"  target="_blank">Título VI. Inversiones Financieras</A> </LI>
                            <LI><A :href="urlServe+ruta + anio2 +'/' + tipo + '/Transitorios.'+tipoAnio"  target="_blank">Transitorios</A> </LI>

                        </UL>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>
<script>
export default {
    data: function(){
        return {
            doc: false,
            pdf: true,
            archivo: '.DOC',
            tipo: 'PDF',
            tipoAnio: 'PDF',
            ruta: 'marco-juridico/Estatal/informacion/Normas/N-Financiera/',
            // extencion: '.pdf',
        }
    },
    props:{
        anio2: null,
    },
    methods:{
        cambio(){
            this.doc = !this.doc;
            this.pdf = !this.pdf;
            console.log('doc: '+this.doc + ' pdf: '+ this.pdf);
            if(this.doc){
                this.archivo = '.PDF';
                this.tipo =  'DOC';
                this.tipoAnio = 'DOCX';
                // this.extencion = '.doc'
            }else{
                this.archivo = '.DOC'
                this.tipo = 'PDF'
                this.tipoAnio = 'PDF'
                // this.extencion = '.pdf'
            }
        }
    }
}
</script>


<style scoped>

.card-header { background-color: #fff; }
.btn-link{ color: #474444; }
.btn:focus { box-shadow: none; }
.btn-link:hover { text-decoration: none; }
.far{ font-size: 20px !important; }
.fa-file-word{ color: #5050d4; }
.fa-file-pdf{ color: #8e0d0d; }
.cambio{
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: .2rem;
    font-size: 12px;
    color: grey;
}


li{
    list-style:none;
    margin-bottom: 1rem;
    border-bottom: 1px dotted rgb(189, 182, 182);
    padding: .2rem;
    padding-left: 0 !important;
    font-size: 14px;
}
li a:hover{ color: #560f2c !important; text-decoration: none; }


/*  */

    .title_document {
        padding: .8rem 1rem;
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    }

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }


    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 20px;
    }

    .sec_imagen{
        width:85% !important;
        background-color: #560F2C;
        margin-top: 3rem;
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex !important;
        justify-content: flex-end !important;
    }
    .card-width{ width: 90%; }

    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }

    .tab-select{
        position: sticky !important;
        top: 15% !important;
        z-index: 1000 !important;
    }

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around !important; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }


    .tab-select{
        position: initial;
        z-index: auto;
    }
}

</style>
